import { Box, IconButton, Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Paper } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useState } from "react";

const HistoryInfoSection = () => {
  const [openDialog, setOpenDialog] = useState(false);

  const handleDialogOpen = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  return (
    <>
      {/*<Box sx={{ fontFamily: "Roboto, sans-serif"}}> */}
      
        <Tooltip title="History details">
          <IconButton onClick={handleDialogOpen} color="inherit">
            <InfoOutlinedIcon />
          </IconButton>
        </Tooltip>
      {/*</Box> */}
      <Dialog open={openDialog} onClose={handleDialogClose}>
        <Paper sx={{ width: '400px', height: '250px' }}>
            <DialogContent>
                <Typography variant="body1">Please note that we are not storing your notes and bookmark information on server. 
                This information is stored in your browser storage. Therefore, clearing your browser history and cache will result in the deletion of your notes
                and bookmark. Please export and download your notes if you want to store it permanently. 
                </Typography>
            </DialogContent>
            {/*<DialogActions>
                <Button variant="contained" onClick={handleDialogClose}>Close</Button>
              </DialogActions>*/}
        </Paper>
      </Dialog>
    </>
  );
};

export default HistoryInfoSection;